import { gql } from '@apollo/client';
export const GET_PRODUCT_PRICES_BY_PRODUCT_ID = gql`
  query ProductPrices($productId: String!) {
    boatnew_products_prices(where: { product_id: { _eq: $productId } }) {
      product_id
      prices
      currency
    }
  }
`;
